import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';

import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { IconSanitizerService } from 'ngx-lib';

export interface IKebabAction {
    label: string;
    action: (data: any) => void;
    show?: (data: any) => boolean | undefined;
}

export interface ICustomCellActionsParams extends ICellRendererParams {
    actions: IKebabAction[];
}

@Component({
    selector: 'app-custom-cell-actions',
    templateUrl: './custom-cell-actions.component.html',
    styleUrls: ['./custom-cell-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkMenuTrigger, CdkMenu, CdkMenuItem]
})
export class CustomCellActionsComponent implements ICellRendererAngularComp {
    params!: ICustomCellActionsParams;
    data!: any;
    visibleActions: IKebabAction[] = [];
    kebabIcon!: SafeHtml;

    private readonly iconSanitizer = inject(IconSanitizerService);

    refresh(): boolean {
        return false;
    }

    agInit(params: ICustomCellActionsParams): void {
        this.params = params;
        this.data = params.data;
        this.kebabIcon = this.iconSanitizer.getIcon('kebab');
        this.updateVisibleActions();
    }

    executeAction(action: IKebabAction, event: Event): void {
        event.stopPropagation();
        action.action(this.data);
    }

    private updateVisibleActions(): void {
        this.visibleActions = this.params.actions.filter((action) => {
            return !action.show || action.show(this.data);
        });
    }
}
